import React, { useEffect, useRef } from 'react';

const ResponsiveTable = ({ children, className = '' }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    const root = containerRef.current;
    if (!root) return;

    const table = root.querySelector('table');
    if (!table) return;

    const headers = Array.from(table.querySelectorAll('thead th')).map((th) =>
      (th.textContent || '').trim()
    );
    const rows = table.querySelectorAll('tbody tr');

    rows.forEach((row) => {
      const cells = row.querySelectorAll('td');
      cells.forEach((cell, index) => {
        const fallbackLabel = `Column ${index + 1}`;
        const label = headers[index] || fallbackLabel;
        cell.setAttribute('data-label', label);
      });
    });
  });

  return (
    <div ref={containerRef} className={`responsive-table overflow-x-auto ${className}`.trim()}>
      {children}
    </div>
  );
};

export default ResponsiveTable;
